var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { grow: "", shrink: "" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-ledger-account-autocomplete", {
                    attrs: { fancy: "", label: _vm.$ct("sale") },
                    model: {
                      value: _vm.config.DefaultSaleCentral,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "DefaultSaleCentral", $$v)
                      },
                      expression: "config.DefaultSaleCentral",
                    },
                  }),
                  _c("app-ledger-account-autocomplete", {
                    attrs: { fancy: "", label: _vm.$ct("purchase") },
                    model: {
                      value: _vm.config.DefaultPurchaseCentral,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "DefaultPurchaseCentral", $$v)
                      },
                      expression: "config.DefaultPurchaseCentral",
                    },
                  }),
                  _c("app-ledger-account-autocomplete", {
                    attrs: { fancy: "", label: _vm.$ct("suspense-account") },
                    model: {
                      value: _vm.config.DefaultSuspenseAccount,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "DefaultSuspenseAccount", $$v)
                      },
                      expression: "config.DefaultSuspenseAccount",
                    },
                  }),
                  _c("app-ledger-account-autocomplete", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("vat-not-subtractable"),
                    },
                    model: {
                      value: _vm.config.VATNotSubtractable,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "VATNotSubtractable", $$v)
                      },
                      expression: "config.VATNotSubtractable",
                    },
                  }),
                  _c("app-ledger-account-autocomplete", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("vat-import-within-eg"),
                    },
                    model: {
                      value: _vm.config.VATImportWithinEG,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "VATImportWithinEG", $$v)
                      },
                      expression: "config.VATImportWithinEG",
                    },
                  }),
                  _c("AppLedgerAccountAutocomplete", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("default-sale-ledger-account"),
                    },
                    model: {
                      value: _vm.config.DefaultSaleLedgerAccountCode,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.config,
                          "DefaultSaleLedgerAccountCode",
                          $$v
                        )
                      },
                      expression: "config.DefaultSaleLedgerAccountCode",
                    },
                  }),
                  _c("AppLedgerAccountAutocomplete", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("default-purchase-ledger-account"),
                    },
                    model: {
                      value: _vm.config.DefaultPurchaseLedgerAccountCode,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.config,
                          "DefaultPurchaseLedgerAccountCode",
                          $$v
                        )
                      },
                      expression: "config.DefaultPurchaseLedgerAccountCode",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: {
                      label: _vm.$ct(
                        "BookOpenClientsAndSuppliersAutomaticallyOnWaitLedger"
                      ),
                    },
                    model: {
                      value:
                        _vm.config
                          .BookOpenClientsAndSuppliersAutomaticallyOnWaitLedger,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.config,
                          "BookOpenClientsAndSuppliersAutomaticallyOnWaitLedger",
                          $$v
                        )
                      },
                      expression:
                        "config.BookOpenClientsAndSuppliersAutomaticallyOnWaitLedger",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.hasFixedAssetsModule
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("h3", [_vm._v(_vm._s(_vm.$ct("fixed-assets-title")))]),
                      _c("app-select-journal", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("depreciation-journal"),
                        },
                        model: {
                          value: _vm.config.DepreciationJournalID,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "DepreciationJournalID", $$v)
                          },
                          expression: "config.DepreciationJournalID",
                        },
                      }),
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          items: _vm.periodicityItems,
                          label: _vm.$ct("depreciation-periodicity"),
                        },
                        model: {
                          value: _vm.config.DepreciationPeriodicity,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "DepreciationPeriodicity", $$v)
                          },
                          expression: "config.DepreciationPeriodicity",
                        },
                      }),
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("auto-book-depreciations") },
                        model: {
                          value: _vm.config.AutoBookDepreciations,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "AutoBookDepreciations", $$v)
                          },
                          expression: "config.AutoBookDepreciations",
                        },
                      }),
                      _c("app-select-journal", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("opening-balance-journal"),
                        },
                        model: {
                          value: _vm.config.OpeningBalanceJournalID,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "OpeningBalanceJournalID", $$v)
                          },
                          expression: "config.OpeningBalanceJournalID",
                        },
                      }),
                      _c("app-ledger-account-autocomplete", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("opening-balance-profit"),
                        },
                        model: {
                          value: _vm.config.OpeningBalanceProfitLedgerCode,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.config,
                              "OpeningBalanceProfitLedgerCode",
                              $$v
                            )
                          },
                          expression: "config.OpeningBalanceProfitLedgerCode",
                        },
                      }),
                      _c("app-ledger-account-autocomplete", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("opening-balance-loss"),
                        },
                        model: {
                          value: _vm.config.OpeningBalanceLossLedgerCode,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.config,
                              "OpeningBalanceLossLedgerCode",
                              $$v
                            )
                          },
                          expression: "config.OpeningBalanceLossLedgerCode",
                        },
                      }),
                      _c("app-ledger-account-autocomplete", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("opening-balance-suspense"),
                        },
                        model: {
                          value: _vm.config.OpeningBalanceSuspenseLedgerCode,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.config,
                              "OpeningBalanceSuspenseLedgerCode",
                              $$v
                            )
                          },
                          expression: "config.OpeningBalanceSuspenseLedgerCode",
                        },
                      }),
                      _c("w-checkbox", {
                        attrs: {
                          label: _vm.$ct("auto-create-opening-balance"),
                        },
                        model: {
                          value: _vm.config.AutoCreateOpeningBalance,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.config,
                              "AutoCreateOpeningBalance",
                              $$v
                            )
                          },
                          expression: "config.AutoCreateOpeningBalance",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }